import { createSlice } from "@reduxjs/toolkit";
import { server_url } from "../core/config_geral";

const initialStateGenerator = () => {
    return {
        works: [],
    }
}

const initialState = {
    loading: true,
    db: initialStateGenerator(),
    toEdit: null,
}

function retornaIndexPeloId(works, id) {
    for(var i = 0; i < works.length ; i ++) {
        if(works[i].id === id)
            return i;
    }

    return -1;
}

export const workSlice = createSlice({
    name: "work",
    initialState,
    reducers: {
        triggerFirstLoad: () => { },
        carregaWorkDB: (state, action) => {
            var db = action.payload;

            if (db == null) db = initialStateGenerator();
            state.db = db;
        },
        updateWorks: (state, action) => {
            var works = [...action.payload];
            state.db.works = works;
        },
        setToEdit: (state, action) => {

            if (action.payload == null) {
                state.toEdit = null
            } else {
                var index = retornaIndexPeloId(state.db.works, action.payload);
                state.toEdit = { ...state.db.works[index] }
            }
        }
    }
});

export const {
    triggerFirstLoad,
    carregaWorkDB,
    updateWorks,
    setToEdit
} = workSlice.actions;

export default workSlice.reducer;